import { List, ListItem } from "@mui/material";
import { hasClaimType } from "data/functions";
import {
  ServiceClaim,
  ServiceSummary,
  ServiceWithClaims,
} from "data/interfaces";
import { ClaimSelectionItem } from "./ClaimSelectionItem";

interface SingleClaimSelectionProps {
  services: ServiceSummary[];
  defaultSelected: ServiceWithClaims[];
  selectedUsersCount: number;
  handleClaimSelect: (
    checked: boolean,
    service: ServiceSummary,
    claim: ServiceClaim,
    claimValue: string
  ) => void;
}

export function ClaimTypeSelection({
  services,
  defaultSelected,
  selectedUsersCount,
  handleClaimSelect,
}: SingleClaimSelectionProps) {
  const userHasClaimType = (
    licenseReference: string,
    claimType: string
  ): boolean => {
    const userServiceClaims = defaultSelected.find(
      (s) => s.licenseReference === licenseReference
    )?.claims;
    return userServiceClaims
      ? hasClaimType(userServiceClaims, claimType)
      : false;
  };

  return (
    <List sx={{ width: "100%" }}>
      {services.map((service) =>
        service.serviceClaims
          .sort((a, b) => (a.shortName > b.shortName ? 1 : -1))
          .map((claim) => (
            <ListItem key={claim.claimType} disablePadding>
              <ClaimSelectionItem
                service={service}
                primaryText={service.name}
                secondaryText={claim.shortName}
                selectedUsersCount={selectedUsersCount}
                defaultChecked={userHasClaimType(
                  service.licenseReference,
                  claim.claimType
                )}
                handleCheckboxSelect={(checked) =>
                  handleClaimSelect(checked, service, claim, claim.claimValue)
                }
              />
            </ListItem>
          ))
      )}
    </List>
  );
}
